import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, MailCheck } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { AuthLayout, FieldLabel, FormError } from "@/components/auth/AuthLayout";
import { api, formatApiError } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try { await api.post("/auth/forgot-password", { email }); setSent(true); } catch (err) { setError(formatApiError(err)); } finally { setBusy(false); }
  };

  return (
    <AuthLayout title="Reset password" subtitle="We'll email you a secure link to set a new password.">
      {sent ? (
        <div className="space-y-6" data-testid="forgot-success">
          <div className="flex gap-3 p-4 rounded-lg border border-[#00E5FF]/30 bg-[#00E5FF]/5">
            <MailCheck className="w-5 h-5 text-[#00E5FF] shrink-0" />
            <p className="text-sm text-slate-300">If an account exists for <b>{email}</b>, a reset link is on its way. It expires in 1 hour.</p>
          </div>
          <Link to="/login" className="text-sm text-[#FFB800] hover:underline" data-testid="back-to-login-link">Back to sign in</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-5" data-testid="forgot-form">
          <div><FieldLabel htmlFor="email">Email</FieldLabel>
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="h-11 bg-[#0a0816] border-[#2d2650] mystic-input" data-testid="forgot-email-input" /></div>
          <FormError error={error} />
          <Button type="submit" disabled={busy} className="w-full h-11 mystic-btn text-[#0B0C10] font-semibold tracking-wide" data-testid="forgot-submit-button">
            {busy && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}Send reset link
          </Button>
          <p className="text-sm text-center"><Link to="/login" className="text-slate-400 hover:text-[#FFB800]" data-testid="forgot-back-login">Back to sign in</Link></p>
        </form>
      )}
    </AuthLayout>
  );
}
